import {
    actionGetNewsRequest,
    actionGetNewsSuccess,
    actionGetNewsFailure,
    actionDeleteNewsRequest,
    actionDeleteNewsSuccess,
    actionDeleteNewsFailure,
    actionPutNewsRequest,
    actionPutNewsSuccess,
    actionPutNewsFailure,
    actionPostNewsRequest,
    actionPostNewsSuccess,
    actionPostNewsFailure,
} from './actions';

import {
    resourcesGetNews,
    resourcesDeleteNews,
    resourcesPutNews,
    resourcesPostNews,
} from './resources';

export const thunksGetNews = () => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionGetNewsRequest());
        return resourcesGetNews(token)
            .then((response) => {
                dispatch(actionGetNewsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionGetNewsFailure(error));
            });
    };
};

export const thunksDeleteNews = (id) => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionDeleteNewsRequest());
        return resourcesDeleteNews(token, id)
            .then((response) => {
                dispatch(actionDeleteNewsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionDeleteNewsFailure(error));
            });
    };
};

export const thunksPutNews = (id) => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionPutNewsRequest());
        return resourcesPutNews(token, id)
            .then((response) => {
                dispatch(actionPutNewsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionPutNewsFailure(error));
            });
    };
};

export const thunksPostNews = (body) => {
    return (dispatch, getState) => {
        const token = getState().getIn(['auth', 'user', 'token']);

        dispatch(actionPostNewsRequest());
        return resourcesPostNews(token, body)
            .then((response) => {
                dispatch(actionPostNewsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(actionPostNewsFailure(error));
            });
    };
};
